var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6667C16 21.6387 16 19.124 17.5627 17.5627C19.124 16 21.6387 16 26.6667 16H29.3333C34.3613 16 36.876 16 38.4373 17.5627C40 19.124 40 21.6387 40 26.6667V29.3333C40 34.3613 40 36.876 38.4373 38.4373C36.876 40 34.3613 40 29.3333 40H26.6667C21.6387 40 19.124 40 17.5627 38.4373C16 36.876 16 34.3613 16 29.3333V26.6667Z",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 22C35.5 22.8284 34.8284 23.5 34 23.5C33.1716 23.5 32.5 22.8284 32.5 22C32.5 21.1716 33.1716 20.5 34 20.5C34.8284 20.5 35.5 21.1716 35.5 22Z",
    stroke: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32C30.2091 32 32 30.2091 32 28C32 25.7909 30.2091 24 28 24C25.7909 24 24 25.7909 24 28C24 30.2091 25.7909 32 28 32Z",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1a246c5c41bcb894677eb360089a1422.svg";
export { ForwardRef as ReactComponent };